import React, { useEffect, useState, useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { History } from 'history'

import styles from '../component-styles/campaign-codes-administration.module.scss'
import { SupportState } from '../store/support-reducer'
import { GraphQLState } from '../store/graphql-reducer'
import {
  CampaignCodeGeneratorStructure,
  GeneratorFields,
} from '../api-client/api-types'
import {
  getCampaignCodeGeneratorAsync,
  deleteGeneratorParameterAsync,
} from '../store/actions'
import Heading from './heading'
import CampaignCodesAdministrationToggleBox from './campaign-codes-administration-toggle-box'
// import TwoColumns, { Column } from './two-columns'
import Button, { ButtonRow } from './button'
import HeaderPanel, { Panel } from './header-panel'
import EditCodeStructureModal from './edit-code-structure-modal'
import ToolTip from './tooltip'

export function getCopyFromValues(paramDefs, paramDef: GeneratorFields) {
  if (paramDef.fieldType === 'input') {
    return paramDefs.filter((item: GeneratorFields): boolean => {
      return item.fieldID !== paramDef.fieldID
    })
  }
  return []
}
interface Props {
  history: History
}

export default function CampaignCodeAdministration({
  history,
}: Props): React.ReactElement | null {
  const { pendingRequests } = useSelector(
    (state: any): SupportState => state.support,
  )
  const { generatedStructure } = useSelector(
    (
      s: any,
    ): {
      generatedStructure: CampaignCodeGeneratorStructure
    } => s.campaignCodes,
  )
  const { graphql }: { graphql: GraphQLState } = useSelector((s: any): any => s)
  const { currentUser } = graphql
  const userPermission = currentUser?.currentAccountPermission || ''

  const dispatch = useDispatch()
  const [form, setForm] = useState(generatedStructure)
  const [showSettings, setShowSettings] = useState(false)

  useEffect((): void => {
    // dispatch(getCampaignCodesAsync())
    dispatch(getCampaignCodeGeneratorAsync())
  }, [])

  useEffect((): void => {
    if (
      userPermission &&
      ['admin', 'support', 'billing'].indexOf(userPermission) === -1
    ) {
      history.push('/track/create-campaign-codes')
    }
  }, [userPermission])

  useEffect((): void => {
    if (generatedStructure !== null) {
      setForm(generatedStructure)
    }
    // eslint-disable-next-line
  }, [generatedStructure])

  const onRemove = (removeID: string): void => {
    // eslint-disable-next-line
    // debugger
    dispatch(deleteGeneratorParameterAsync({ removeID }))
    setForm({
      ...form,
      paramDefs: form.paramDefs.filter(
        (aParamDef): boolean => removeID !== aParamDef.fieldID,
      ),
    })
  }

  const parentsList: GeneratorFields[] = useMemo(() => {
    if (!form || !form.paramDefs) {
      return []
    }
    return form.paramDefs.filter((item: GeneratorFields) => {
      const { fieldType, selectFields } = item
      return fieldType === 'select' && selectFields
    })
  }, [form])

  const showEditCodeButton = useMemo(() => {
    return pendingRequests.length === 0
  }, [pendingRequests])

  if (
    !userPermission ||
    !generatedStructure ||
    !generatedStructure.paramDefs ||
    !form
  )
    return null

  return (
    <>
      <HeaderPanel>
        <Panel>
          <Heading type={3} align="left" className={styles.heading}>
            Parameters
            <ToolTip
              showUnder
              className={styles.tooltip}
              message="The elements which are added to the end of your campaign link after your URL. You can add dropdown options and change the data validation rules by expanding each parameter."
            />
          </Heading>
        </Panel>
        {showEditCodeButton && (
          <Panel>
            <ButtonRow className={styles.panelButtonRow}>
              <Button
                onClick={(): void => {
                  setShowSettings(!showSettings)
                }}
                type="edit"
              >
                Edit code structure
              </Button>
            </ButtonRow>
          </Panel>
        )}
      </HeaderPanel>
      <div className={styles.toggleWrapper}>
        {form.paramDefs.map(
          (paramDef, index: number): React.ReactElement | null => {
            return (
              <CampaignCodesAdministrationToggleBox
                key={`${paramDef.fieldID}`}
                paramDef={paramDef}
                parentsList={parentsList}
                onRemove={onRemove}
                copyFromValues={getCopyFromValues(form.paramDefs, paramDef)}
                allParams={form.paramDefs.map((param) => param.fieldName)}
              />
            )
          },
        )}
      </div>
      {showSettings && (
        <EditCodeStructureModal
          onHide={() => {
            setShowSettings(false)
          }}
        />
      )}
    </>
  )
}
